/** Official-style brand marks. Do not show these as working login controls unless the provider is on. */

export function GoogleMark({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#EA4335"
        d="M12 10.2v3.6h5.1c-.2 1.2-.9 2.2-1.8 2.9l2.9 2.3c1.7-1.6 2.7-3.9 2.7-6.6 0-.6-.1-1.2-.2-1.8H12z"
      />
      <path
        fill="#34A853"
        d="M6.6 14.3 5.5 15.1l-3.1 2.4C4.4 20.8 8 23 12 23c2.7 0 5-.9 6.7-2.4l-2.9-2.3C14.7 19.1 13.4 19.6 12 19.6c-2.7 0-5-1.8-5.8-4.3z"
      />
      <path
        fill="#4A90E2"
        d="M3.1 6.5C2.4 8 2 9.9 2 12s.4 4 1.1 5.5l3.5-2.7C6.2 13.8 6 12.9 6 12s.2-1.8.6-2.8L3.1 6.5z"
      />
      <path
        fill="#FBBC05"
        d="M12 4.4c1.5 0 2.8.5 3.9 1.5l2.9-2.9C16.9 1.1 14.7 0 12 0 8 0 4.4 2.2 2.4 5.5L6.6 8.2C7 5.7 9.3 4.4 12 4.4z"
      />
    </svg>
  );
}

export function TelegramMark({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="#26A5E4" />
      <path
        fill="#fff"
        d="M17.6 7.3 5.9 11.8c-.8.3-.8.8-.1 1l3 1 1.2 3.5c.2.4.6.5.9.3l1.7-1.3 3.2 2.4c.6.3 1 .2 1.2-.5l2.1-9.8c.2-.9-.3-1.3-1.5-.8zM9.8 13.9l7.2-4.5c.3-.2.6 0 .4.3l-6.2 5.6-.2 2.3-1.2-3.7z"
      />
    </svg>
  );
}

export function MailMark({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="m4.5 7 7.5 6 7.5-6" fill="none" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

export function PhoneMark({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M8 4h3l1 4-2.2 1.2a12 12 0 0 0 5 5L16 12l4 1v3c0 1-1 2-2 2C9 18 2 11 2 3c0-1 1-2 2-2z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}
